import React from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { Button, Col, Form, Row, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Newequipement = () => {
    const [validated, setValidated] = React.useState(false);
    const [formd, setFrom] = React.useState({});
    const [l, setL] = React.useState(false);
    const [valueStatut, setValueStatut] = React.useState(null);
    const navigate = useNavigate();
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity() === false) {
            return;
        }
        setValidated(true);
        setL(true);


        let d = formd;
        d.create_At = new Date();
        d.update_At = new Date();


        firebase.firestore().collection('equiments').add(d).then(() => {
            console.log("Document successfully written!");
            toast.success("Équipement créer avec succès");
            navigate('/equiment/edit/'+d.id);
        })
            .catch((error) => {
                var errorCode = error.code;
                var errorMessage = error.message;
                // ..
                setL(false);
                toast.error(errorMessage);
            });

    };


    const handleChange = e => {
        let d = { ...formd };
        d[e.target.name] = e.target.value;
        setFrom(d);
    };


    return (
        <FalconComponentCard>
            <FalconComponentCard.Header title="Nouvel équipement" light={false} noPreview={true} />
            <FalconComponentCard.Body >
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="4" controlId="title">
                            <Form.Label>Titre</Form.Label>
                            <Form.Control
                                onChange={handleChange}
                                required
                                name="title"
                                type="text"
                                placeholder="Votre titre.."
                            />
                            <Form.Control.Feedback type="invalid">
                                Veuillez indiquez votre titre.
                            </Form.Control.Feedback>
                            <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="titleen">
                            <Form.Label>Titre (Anglais)</Form.Label>
                            <Form.Control
                                onChange={handleChange}
                                required
                                name="titleen"
                                type="text"
                                placeholder="Votre titre en anglais.."
                            />
                            <Form.Control.Feedback type="invalid">
                                Veuillez indiquez votre titre.
                            </Form.Control.Feedback>
                            <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="icon">
                            <Form.Label>Icone</Form.Label>
                            <Form.Control
                                type="text"
                                name="icon"
                                onChange={handleChange}
                                placeholder="Icone"
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="5" controlId="category">
                            <Form.Label>Catégorie (requis)</Form.Label>
                            <Select
                                closeMenuOnSelect={true}
                                required 
                                options={[
                                    { value: 'essential', label: 'Essentiel' },
                                    { value: 'outdoor', label: 'Extérieur' },
                                    { value: 'entertainment', label: 'Bien-être & Divertissement' },
                                ]}
                                placeholder='Choisir la categorie...'
                                classNamePrefix="react-select"
                                value={valueStatut}
                                onChange={value => {
                                    setValueStatut(value)

                                    let d = {...formd};
                                    d['category'] = value;
                                    setFrom(d);

                                }}
                            />

                        </Form.Group>
                        {formd.icon && <FontAwesomeIcon icon={formd.icon} />}
                        <Form.Group as={Col} md="4" controlId="linkicon">
                            <Form.Label>Lien d'icone</Form.Label>
                            <Form.Control
                                type="text"
                                name="linkicon"
                                onChange={handleChange}
                                placeholder="Lien de l'image si pas d'icone"
                            />
                        </Form.Group>

                    </Row>
                    <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Créer'}</Button>
                </Form>
                <p>Vous pouvez rechercher un nom d'icon ici: <a target='_blank' href='https://fontawesome.com/icons'>https://fontawesome.com/icons</a></p>
            </FalconComponentCard.Body>
        </FalconComponentCard>
    );
    //   <> 

    //     <FalconComponentCard>
    //       
    //       <FalconComponentCard.Body code={exampleCode} language="jsx" />
    //     </FalconComponentCard> 
    //   </>
};

export default Newequipement;
